@if (options.title || options.subTitle || options.enableBackdropDismiss) {
  <div class="alert-header">
    <div class="alert-header-text">
      @if (options.title) {
        <div class="alert-title">
          {{options.title}}
        </div>
      }
      @if (options.subTitle) {
        <div class="alert-subtitle">
          {{options.subTitle}}
        </div>
      }
    </div>
    @if (options.enableBackdropDismiss !== false) {
      <div class="alert-close" (click)="handleCloseClick()">
        <cs-icon name="close"></cs-icon>
      </div>
    }
  </div>
}
@if (options.message) {
  <div class="alert-message">
    {{options.message}}
  </div>
}
@if (options.messageMarkdown) {
  <div class="alert-message">
    <cs-markdown [textMarkdown]="options.messageMarkdown"></cs-markdown>
  </div>
}
@if (isRadioGroup()) {
  <div class="alert-radio-group">
    @for (input of options.inputs; track input) {
      <div class="radio-button" [class.selected]="input.checked" (click)="selectRadio(input)">
        <div class="radio-content">
          <div class="radio-input" [class.checked]="input.checked"></div>
          <div class="radio-text">
            <div class="radio-title">{{input.label}}</div>
            @if (input.description) {
              <div class="radio-description">{{input.description}}</div>
            }
          </div>
        </div>
      </div>
    }
  </div>
} @else if (options.inputs && options.inputs.length > 0) {
  <cs-item-list class="alert-input-group">
    @for (input of options.inputs; track input) {
      <cs-item vertical>
        @if (input.label) {
          <cs-label>{{input.label}}</cs-label>
        }
        @if (input.type === 'select') {
          <cs-select [value]="input.value" (valueChange)="input.value = $event" [placeholder]="input.placeholder || LL.common.placeholders.select()">
            @for (opt of input.selectOptions; track opt.value) {
              <cs-select-option [value]="opt.value" [label]="opt.label"></cs-select-option>
            }
          </cs-select>
        } @else if (input.type === 'time') {
          <cs-input-time [(time)]="input.value"></cs-input-time>
        } @else {
          <cs-input class="alert-input" id="{{input.id}}" [(value)]="input.value"
            [min]="input.min" [max]="input.max" [name]="input.name" [type]="input.type" [placeholder]="input.placeholder"
            [checked]="input.checked" [disabled]="input.disabled">
          </cs-input>
        }
      </cs-item>
    }
  </cs-item-list>
}
@if (options.buttons && options.buttons.length > 0) {
  <div class="alert-button-group" [ngClass]="{'long-buttons': hasLongButtons()}">
    @for (button of options.buttons; track button) {
      <cs-button medium class="alert-button"
        [ngClass]="{'primary': button.role === 'primary', 'cancel': button.role === 'cancel'}"
        [attr.secondary]="button.role !== 'primary' ? '' : null"
        [attr.e2e-locator]="e2eLocatorFor(button)"
        (click)="handleButtonClick($event, button)">
        {{button.text}}
        @if (button.badge) {
          <cs-badge [color]="button.role === 'primary' ? 'blue' : 'gray'">{{button.badge}}</cs-badge>
        }
      </cs-button>
    }
  </div>
}